
import { Grid, Typography } from '@mui/material';
import { IRoom } from '../../../interfaces/IPartnerPms';
import { useCallback, useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import FormHelper from '../../../helpers/FormHelper';
import DefaultConstants from '../../../data/Constants';
import PartnerPmsService from '../../../services/PartnerPmsService';
import { RoomStatusData, RoomStatusEnum } from '../../../data/Enums';
import TextField from '../../TextField';
import useState from '../../../hooks/useState';


const executionPriority = RoomStatusData[RoomStatusEnum.ExecutionPriority];


interface IExecutionPriorityConfirmationDialogProps extends IDefaultDialogProps {
    room: IRoom;
    handleRefreshSelectedRoom: () => void;
}

interface IStateValues {
    description: string;
}

const ExecutionPriorityConfirmationDialog: React.FC<IExecutionPriorityConfirmationDialogProps> = ({
    open,
    handleClose,
    room,
    handleRefreshSelectedRoom
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        description: ''
    });


    useEffect(() => {
        state.update('description', room.executionPriorityDescription ?? '');
        // eslint-disable-next-line
    }, [room]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(event);
        formData = FormHelper.Add(formData, 'roomId', room.id);
        formData = FormHelper.Add(formData, 'enableExecutionPriority', (!room.executionPriority).toString());

        PartnerPmsService.UpdateRoomExecutionPriority(formData).then(() => {
            handleRefreshSelectedRoom();
            handleClose();
        });
        // eslint-disable-next-line
    }, [room]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='no' onClick={handleClose} />,
            <ActionButton action='yes' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return <>
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate(executionPriority.name)}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        {translate(room.executionPriority ? '_governanceDialogDisableExecutionPriorityDescription' : '_governanceDialogEnableExecutionPriorityDescription')}
                    </Typography>
                </Grid>

                <Grid item xs={12} paddingBottom={2}>
                    <TextField 
                        label={translate('description')} 
                        name='description' 
                        value={state.values.description} 
                        required={false}
                        onChange={e => state.update('description', e.target.value)}
                        multiline={true}
                        minRows={4}
                        maxRows={4}
                        disabled={room.executionPriority}
                    />
                </Grid>
            </Grid>
        </Dialog>
    </>;
}

export default ExecutionPriorityConfirmationDialog;